import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "params-heading" }
const _hoisted_3 = {
  key: 2,
  class: "param-error",
  role: "alert"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 3,
  class: "param-error",
  role: "alert"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

import { computed, type HTMLAttributes } from "vue";
import { NSelect } from "naive-ui";
import TypedValueInput from "../../../TypedValueInput.vue";
import { studioSelectTheme } from "../../../studioSelectTheme";
import { getTypedValueError } from "../../../typedValueInput";
import { usePresetReferences, compatibleReference } from "../../../EntityPresetEditor/presetReferences";
import type { StyleParameter } from "../../../EntityPresetEditor/styleParameters";
import "../../../../studioSelect.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'StyleParameterFields',
  props: {
    modelValue: {},
    parameters: {},
    label: { default: "参数" },
    presetLabel: { default: "对应类型" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const references = usePresetReferences();
// Keep teleported menus within the Timeline's outside-click boundary.
const clipMenuProps: HTMLAttributes & { "data-clip-editor": string } = { "data-clip-editor": "", class: "studio-select-menu" };

const fields = computed(() => Array.from({ length: Math.max(props.modelValue.length, props.parameters?.length ?? 0) }, (_, index) => {
  const parameter = props.parameters?.[index];
  const reference = parameter?.reference;
  const source = reference ? references.sources.value.find(item => item.value === reference && compatibleReference(item, "Int32")) : undefined;
  const value = props.modelValue[index] ?? parameter?.defaultValue ?? "0";
  const availableOptions = reference ? references.options(reference, "Int32").filter(option => option.value !== "" && !getTypedValueError("Int32", option.value)) : [];
  const options = reference && !availableOptions.some(option => option.value === value)
    ? [{ label: `${value || "（空）"}（当前值）`, value, disabled: true }, ...availableOptions]
    : availableOptions;
  return { index, key: parameter?.id ?? `parameter-${index}`, name: parameter?.name || `参数 ${index + 1}`, reference, source, value, options, availableOptions };
}));

function updateValue(index: number, value: string) {
  const next = fields.value.map(field => field.value);
  next[index] = value;
  emit("update:modelValue", next);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "style-parameters",
    "aria-label": __props.label
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _cache[0] || (_cache[0] = _createTextVNode("参数 ", -1)),
        _createElementVNode("small", null, _toDisplayString(fields.value.length) + "/100", 1)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "param-type" }, "整数", -1))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, (field) => {
      return (_openBlock(), _createElementBlock("label", {
        key: field.key,
        class: "parameter-field"
      }, [
        _createElementVNode("span", null, _toDisplayString(field.name), 1),
        (field.reference)
          ? (_openBlock(), _createBlock(_unref(NSelect), {
              key: 0,
              "theme-overrides": _unref(studioSelectTheme),
              value: field.value,
              options: field.options,
              filterable: "",
              "menu-props": clipMenuProps,
              disabled: !_unref(references).readyFor(field.reference),
              "aria-label": `${__props.label} ${field.name}预设值`,
              placeholder: "选择配置记录",
              "onUpdate:value": ($event: any) => (updateValue(field.index, $event))
            }, null, 8, ["theme-overrides", "value", "options", "disabled", "aria-label", "onUpdate:value"]))
          : (_openBlock(), _createBlock(TypedValueInput, {
              key: 1,
              class: "parameter-input",
              "model-value": field.value,
              "value-type": "Int32",
              "aria-label": `${__props.label} ${field.name}`,
              "onUpdate:modelValue": ($event: any) => (updateValue(field.index, $event))
            }, null, 8, ["model-value", "aria-label", "onUpdate:modelValue"])),
        (field.reference && _unref(references).errorFor(field.reference))
          ? (_openBlock(), _createElementBlock("small", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(references).errorFor(field.reference)) + " ", 1),
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (_unref(references).retryFor(field.reference).catch(() => undefined))
              }, "重新加载引用", 8, _hoisted_4)
            ]))
          : (field.reference && _unref(references).readyFor(field.reference) && !field.source)
            ? (_openBlock(), _createElementBlock("small", _hoisted_5, [
                _cache[2] || (_cache[2] = _createTextVNode(" 值来源已失效或不支持整数；当前值已保留。请在预设设置中修正值来源，再应用预设参数。 ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (_unref(references).retryFor(field.reference).catch(() => undefined))
                }, "重新加载引用", 8, _hoisted_6)
              ]))
            : (field.reference && _unref(references).readyFor(field.reference) && !field.availableOptions.length)
              ? (_openBlock(), _createElementBlock("small", _hoisted_7, " 值来源暂无有效整数记录，请在预设设置中补充。 "))
              : _createCommentVNode("", true),
        (field.reference)
          ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(field.source?.label || '预设值来源') + " · 当前值：" + _toDisplayString(field.value || '（空）') + "。选择记录后复制整数值。", 1))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (!fields.value.length)
      ? (_openBlock(), _createElementBlock("small", _hoisted_9, "去「预设设置 → " + _toDisplayString(__props.presetLabel) + "」中配置参数。", 1))
      : (_openBlock(), _createElementBlock("small", _hoisted_10, "参数名称和顺序由类型预设配置；节点按顺序传入整数。"))
  ], 8, _hoisted_1))
}
}

})